import React from 'react';
import { Size } from '../../../styles/theme.mjs';
import Logo, { LogoVariant } from '../../Basic/Icons/Logo/Logo.mjs';
import AppStoreIcon from '../../Basic/Icons/StoreIcons/AppStoreIcon.mjs';
import GooglePlayIcon from '../../Basic/Icons/StoreIcons/GooglePlayIcon.mjs';
import LineSeparator from '../../Basic/LineSeparator/LineSeparator.mjs';
import StyledLink from '../../Basic/Link/Link.mjs';
import HorizontalList from '../../Basic/Lists/HorizontalList/HorizontalList.mjs';
import VerticalList from '../../Basic/Lists/VerticalList/VerticalList.mjs';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import TextComponent from '../../Typography/Text/Text.mjs';
import { StyledFooterGrid, StyledFooterGridItem, StyledTopListGridItem, StyledLineSeparatorGridItem, StyledBottomListGridItem, StyledCopyrightGridItem } from './Footer.styles.mjs';
import { useTheme } from 'styled-components';

const year = new Date().getFullYear();
const Footer = ({ topLists, bottomOptions, homeUrl, externalLinks }) => {
    const theme = useTheme();
    return (React.createElement(StyledFooterGrid, null,
        React.createElement(StyledFooterGridItem, { area: ['auto', '1 / 1', '1 / 1 / auto / span 2'] },
            React.createElement(FlexContainer, { direction: "column", gap: ['40px', '60px'], alignItems: ['center', 'flex-start'] },
                React.createElement(StyledLink, { href: homeUrl },
                    React.createElement(Logo, { variant: LogoVariant.UNCOLORED })),
                React.createElement(FlexContainer, { direction: ['row', 'column'], gap: "16px" },
                    React.createElement(StyledLink, { href: externalLinks.appStoreUrl, rel: "noopener noreferrer", target: "_blank" },
                        React.createElement(AppStoreIcon, null)),
                    React.createElement(StyledLink, { href: externalLinks.googlePlayUrl, rel: "noopener noreferrer", target: "_blank" },
                        React.createElement(GooglePlayIcon, null))))),
        topLists.map(({ options, heading }, index) => (React.createElement(StyledTopListGridItem, { key: index, area: ['auto', `1 / ${2 + index}`, `1 / ${3 + index}`] },
            React.createElement(VerticalList, { heading: heading, options: options })))),
        React.createElement(StyledLineSeparatorGridItem, { area: ['auto', '2 / 1 / auto / span 4', '2 / 1 / auto / span 5'] },
            React.createElement(LineSeparator, null)),
        React.createElement(StyledBottomListGridItem, { area: ['auto', '3 / 2 / auto / span 2', '3 / 3 / auto / span 3'] },
            React.createElement(HorizontalList, { options: bottomOptions, wrap: true })),
        React.createElement(StyledCopyrightGridItem, { area: ['auto', '3 / 1'] },
            React.createElement(TextComponent, { tag: "p", size: Size.Tiny, color: theme.colors.mutedTextColor },
                "\u00A9 ",
                year,
                " N12N, LLC"))));
};

export { Footer as default };
//# sourceMappingURL=Footer.mjs.map
